
import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container mx-auto px-4 py-12 text-gray-800 dark:text-gray-100">
      {/* ================= ENGLISH ================= */}
      <h1 className="text-4xl font-bold mb-3 text-center">
        Terms and Conditions
      </h1>
      <p className="text-center text-sm text-gray-500 dark:text-gray-400 mb-10">
        Last updated: January 2026
      </p>

      <section className="space-y-8 max-w-4xl mx-auto">
        {/* 1. Introduction */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">1. Introduction</h2>
          <p>
            Welcome to PTfinderNow. By accessing, registering, or using our
            website, platform, or services, you agree to be legally bound by
            these Terms and Conditions. If you do not agree, you must not use
            the platform.
          </p>
        </div>

        {/* 2. Licensing */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">2. Licensing</h2>
          <p>
               PTfinderNow is a Dubai-licensed business operating under an E-Trader (Professional) License issued by the Dubai Department of Economy and Tourism (DET), United Arab Emirates.

  <ul className="list-disc pl-6 mt-2">
    <li><strong>License Number:</strong> 1561365</li>
    <li><strong>Licensed Activity:</strong> Electronic Dealing Portal / Online Marketplace</li>
    <li><strong>Legal Form:</strong> Sole Establishment</li>
    <li><strong>Jurisdiction:</strong> Emirate of Dubai, UAE</li>
  </ul>
              <p className="mt-2">
  PTfinderNow operates exclusively as an online platform and does not operate
  physical offices, training facilities.
</p>


          </p>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            {/* Optional: add license number if you have it */}
            {/* License details may be provided upon request or displayed on the Platform. */}
          </p>
        </div>

        {/* 3. Platform Nature */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">3. Platform Nature</h2>
          <p>
            PTfinderNow is a technology-based marketplace that connects clients
            with independent experts across multiple specialties, including but
            not limited to sport & fitness, languages, education, school
            subjects, music, arts, programming, business, photography, cooking,
            life coaching, mindset, beauty, and lifestyle services.
          </p>
          <p className="mt-2">
            PTfinderNow does not employ experts, does not act as an agent, and
            does not provide services directly. All experts operate
            independently and at their own responsibility.
          </p>
        </div>

        {/* 4. Expert Accounts & Subscriptions */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            4. Expert Accounts & Subscriptions
          </h2>
          <p>
            Experts can keep a public coach listing for free. The optional
            Lead Access subscription is AED 199 per month or AED 1,910.00 per
            year (20% less than twelve monthly payments) and unlocks the
            ability to read and reply to client inquiries. There is no free
            trial. It renews at the selected interval until canceled;
            canceling leaves the public listing available.
          </p>
          <p className="mt-2">
            Selected experts may have time-limited early access. Existing
            subscriptions retain their agreed terms until changed or ended.
          </p>
          <p className="mt-2">
            PTfinderNow reserves the right to modify pricing, plans, features,
            promotions, or free periods at any time. Subscription fees are
            charged for platform access only and do not guarantee bookings,
            income, visibility, or results.
          </p>
          <p className="mt-2">
            Any taxes, VAT (if applicable), or government fees related to an
            expertâ€™s services or earnings are the expertâ€™s responsibility.
          </p>
        </div>

        {/* 5. Expert Verification & Reviews */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            5. Expert Verification & Reviews
          </h2>
          <p>
            PTfinderNow does not verify the identity, qualifications,
            certifications, licenses, or background of experts unless
            explicitly stated. Users are responsible for verifying experts
            independently before engaging in any session.
          </p>
          <p className="mt-2">
            Reviews and ratings displayed on the platform may come from users,
            third-party sources, or external platforms such as Google. While
            some reviews may be verified, PTfinderNow does not guarantee their
            accuracy, authenticity, or completeness.
          </p>
          <p className="mt-2">
            Reviews reflect the personal opinions of users and do not represent
            PTfinderNowâ€™s endorsement of any expert.
          </p>
          <p className="mt-2">
            PTfinderNow makes no guarantees regarding the quality, performance,
            reliability, or suitability of any expert.
          </p>
        </div>

        {/* 6. Expert Content Responsibility */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            6. Expert Content & Profile Responsibility
          </h2>
          <p>
            Experts are solely responsible for all information, content,
            descriptions, pricing, qualifications, media, and claims published
            on their profiles or shared with clients.
          </p>
          <p className="mt-2">
            Experts must not provide false, misleading, fraudulent, or illegal
            information. PTfinderNow is not responsible or liable for inaccurate
            or fake content posted by experts.
          </p>
          <p className="mt-2">
            PTfinderNow reserves the right to remove or suspend any expert
            profile or content that is suspected to be false, misleading, or
            harmful, without notice or refund.
          </p>
        </div>

        {/* 7. Public Profile & Contact Details */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            7. Public Profile & Contact Details
          </h2>
          <p>
            PTfinderNow is a public marketplace. By registering as an Expert,
            you acknowledge and agree that certain profile information may be
            publicly visible to clients and visitors.
          </p>
          <p className="mt-2">
            This may include your name, profile photo, description, category,
            location, pricing, availability slots, gallery, reviews, and (if
            enabled) your contact details such as email, phone number, and
            WhatsApp.
          </p>
          <p className="mt-2">
            Experts voluntarily provide contact details and consent to their
            public display and/or sharing with clients. PTfinderNow is not
            responsible for communications, agreements, or disputes that occur
            once contact details are displayed or shared.
          </p>
        </div>

        {/* 8. User Responsibilities */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">8. User Responsibilities</h2>
          <p>
            All users agree to provide accurate information, behave respectfully,
            and comply with all applicable laws. Fraudulent, abusive, misleading,
            or illegal behavior is strictly prohibited.
          </p>
        </div>

        {/* 9. Age Requirement */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            9. Age Requirement (Minors)
          </h2>
          <p>
            The Platform is intended for users who are 18 years old or older. If
            you are under 18, you may use the Platform only with the consent and
            supervision of a parent or legal guardian.
          </p>
          <p className="mt-2">
            Experts must not provide services to minors without confirming
            appropriate parental/guardian consent where required, and must
            comply with all applicable child-safety and safeguarding laws.
            PTfinderNow is not responsible for verifying a userâ€™s age or
            obtaining parental consent.
          </p>
        </div>

        {/* 10. Sessions */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            10. Sessions (Physical & Online)
          </h2>
          <p>
            Sessions may be conducted in-person or online. The format, location,
            duration, pricing, and conditions of any session are agreed solely
            between the client and the expert.
          </p>
          <p className="mt-2">
            PTfinderNow is not a party to any agreement and does not supervise,
            control, or guarantee how sessions are delivered.
          </p>
        </div>

        {/* 11. Risk Acknowledgment */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            11. Risk Acknowledgment
          </h2>
          <p>
            Some services offered on the platform may involve physical,
            emotional, financial, or personal risks. This includes, but is not
            limited to sports training, fitness activities, nutrition guidance,
            life coaching, or business advice.
          </p>
          <p className="mt-2">
            By using PTfinderNow, clients voluntarily assume all risks and
            confirm they are medically and mentally fit where applicable.
          </p>
        </div>

        {/* 12. No Professional Advice */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            12. No Professional Advice
          </h2>
          <p>
            Experts provide educational and informational services only.
            PTfinderNow does not provide medical, psychological, legal, or
            financial advice. Users should consult qualified professionals
            where appropriate.
          </p>
        </div>

        {/* 13. Thanks Gifts */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">13. Thanks Gifts</h2>
          <p>
            PTfinderNow may allow clients to send voluntary â€œThanks Giftsâ€ to
            experts as a gesture of appreciation.
          </p>
          <p className="mt-2">
            Thanks Gifts are voluntary, non-refundable, not wages or salaries,
            and do not guarantee outcomes or continued service.
          </p>
          <p className="mt-2">
            Thanks Gifts do not create any employment, partnership, or agency
            relationship between PTfinderNow and experts.
          </p>
          <p className="mt-2">
            Thanks Gifts (if enabled) may be processed by third-party payment
            providers such as Stripe and are subject to their terms, compliance,
            verification, and approval requirements. PTfinderNow does not
            control, guarantee, or take responsibility for payment provider
            approvals, delays, rejections, reversals, chargebacks, or payout
            decisions.
          </p>
          <ul className="list-disc pl-6 mt-2">
            <li>80% to the expert</li>
            <li>
              20% platform service fee (including payment processing fees such as
              Stripe)
            </li>
          </ul>
        </div>

        {/* 14. Payments & Refunds */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            14. Payments, Cancellations & Refunds
          </h2>
          <p>
            PTfinderNow does not currently process session payments between
            clients and experts. Any session-related payments, cancellations, or
            refunds must be handled directly between them.
          </p>
          <p className="mt-2">
            PTfinderNow may introduce in-platform payments in the future,
            subject to updated terms and applicable laws.
          </p>
          <p className="mt-2">
            Subscription fees paid to PTfinderNow are non-refundable, except
            where required by applicable law.
          </p>
        </div>

        {/* 15. Technical Issues */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            15. Technical Issues & Availability
          </h2>
          <p>
            PTfinderNow may experience bugs, errors, maintenance downtime,
            delays, or temporary service interruptions.
          </p>
          <p className="mt-2">
            No refunds will be issued for downtime, bugs, errors, or technical
            issues. Users agree to act reasonably and patiently while issues are
            being resolved.
          </p>
        </div>

        {/* 16. Prohibited Conduct */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">16. Prohibited Conduct</h2>
          <p>
            Users must not post illegal content, impersonate others, manipulate
            platform features, or harm the integrity of the marketplace.
            Violations may result in immediate suspension or permanent removal.
          </p>
        </div>

        {/* 17. Disclaimer */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            17. Disclaimer of Warranties
          </h2>
          <p>
            PTfinderNow is provided on an â€œas isâ€ and â€œas availableâ€ basis. We do
            not guarantee availability, accuracy, reliability, or uninterrupted
            service.
          </p>
        </div>

        {/* 18. Limitation */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            18. Limitation of Liability
          </h2>
          <p>
            To the maximum extent permitted by law, PTfinderNow shall not be
            liable for injuries, losses, disputes, technical issues, lost income,
            or damages arising from platform use or expert services.
          </p>
        </div>

        {/* 19. Indemnification */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">19. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless PTfinderNow from any claims,
            damages, liabilities, or legal actions arising from your use of the
            platform or interactions with other users.
          </p>
        </div>

        {/* 20. Termination */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">20. Termination</h2>
          <p>
            PTfinderNow reserves the right to suspend or terminate accounts at
            any time, with or without notice, to protect the platform, users, or
            legal interests.
          </p>
        </div>

        {/* 21. Governing Law */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">21. Governing Law</h2>
          <p>
            These Terms are governed by the laws of the United Arab Emirates.
            Any dispute shall be subject to the exclusive jurisdiction of the
            courts of Dubai, UAE.
          </p>
        </div>

        {/* 22. Changes */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            22. Changes to These Terms
          </h2>
          <p>
            PTfinderNow may update these Terms at any time. Continued use of the
            platform constitutes acceptance of the updated Terms.
          </p>
        </div>

        {/* 23. Contact */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">23. Contact Us</h2>
          <p>
            For any questions regarding these Terms, contact{" "}
            <a
              href="mailto:info@ptfindernow.com"
              className="text-blue-500 hover:underline"
            >
              info@ptfindernow.com
            </a>
            .
          </p>
        </div>
      </section>

      {/* ================= ARABIC (FULL SAME AS ENGLISH) ================= */}
      <section dir="rtl" className="space-y-8 max-w-4xl mx-auto mt-20">
        <h1 className="text-4xl font-bold mb-3 text-center">Ø§Ù„Ø´Ø±ÙˆØ· ÙˆØ§Ù„Ø£Ø­ÙƒØ§Ù…</h1>
        <p className="text-center text-sm text-gray-500 dark:text-gray-400 mb-10">
          Ø¢Ø®Ø± ØªØ­Ø¯ÙŠØ«: ÙŠÙ†Ø§ÙŠØ± 2026
        </p>

        {/* 1. Ø§Ù„Ù…Ù‚Ø¯Ù…Ø© */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">1. Ø§Ù„Ù…Ù‚Ø¯Ù…Ø©</h2>
          <p>
            Ù…Ø±Ø­Ø¨Ù‹Ø§ Ø¨Ùƒ ÙÙŠ PTfinderNow. Ù…Ù† Ø®Ù„Ø§Ù„ Ø¯Ø®ÙˆÙ„Ùƒ Ø£Ùˆ ØªØ³Ø¬ÙŠÙ„Ùƒ Ø£Ùˆ Ø§Ø³ØªØ®Ø¯Ø§Ù…Ùƒ Ù„Ù…ÙˆÙ‚Ø¹Ù†Ø§
            Ø§Ù„Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ Ø£Ùˆ Ù…Ù†ØµØªÙ†Ø§ Ø£Ùˆ Ø®Ø¯Ù…Ø§ØªÙ†Ø§ØŒ ÙØ¥Ù†Ùƒ ØªÙˆØ§ÙÙ‚ Ø¹Ù„Ù‰ Ø§Ù„Ø§Ù„ØªØ²Ø§Ù… Ø¨Ù‡Ø°Ù‡ Ø§Ù„Ø´Ø±ÙˆØ·
            ÙˆØ§Ù„Ø£Ø­ÙƒØ§Ù… Ø¨Ø´ÙƒÙ„ Ù‚Ø§Ù†ÙˆÙ†ÙŠ. Ø¥Ø°Ø§ Ù„Ù… ØªÙˆØ§ÙÙ‚ Ø¹Ù„Ù‰ Ù‡Ø°Ù‡ Ø§Ù„Ø´Ø±ÙˆØ·ØŒ ÙŠØ¬Ø¨ Ø¹Ù„ÙŠÙƒ Ø¹Ø¯Ù…
            Ø§Ø³ØªØ®Ø¯Ø§Ù… Ø§Ù„Ù…Ù†ØµØ©.
          </p>
        </div>

        {/* 2. Ø§Ù„ØªØ±Ø®ÙŠØµ */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">2. Ø§Ù„ØªØ±Ø®ÙŠØµ</h2>
          <p>
PTfinderNow Ù…Ù†Ø´Ø£Ø© Ù…Ø±Ø®ØµØ© ÙÙŠ Ø¥Ù…Ø§Ø±Ø© Ø¯Ø¨ÙŠØŒ ØªØ¹Ù…Ù„ Ø¨Ù…ÙˆØ¬Ø¨ Ø±Ø®ØµØ© ØªØ§Ø¬Ø± Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ (Ù…Ù‡Ù†ÙŠØ©) ØµØ§Ø¯Ø±Ø© Ø¹Ù† Ø¯Ø§Ø¦Ø±Ø© Ø§Ù„Ø§Ù‚ØªØµØ§Ø¯ ÙˆØ§Ù„Ø³ÙŠØ§Ø­Ø© ÙÙŠ Ø¯Ø¨ÙŠ â€“ Ø¯ÙˆÙ„Ø© Ø§Ù„Ø¥Ù…Ø§Ø±Ø§Øª Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© Ø§Ù„Ù…ØªØ­Ø¯Ø©.
  <ul className="list-disc pr-6 mt-2">
    <li><strong>Ø±Ù‚Ù… Ø§Ù„Ø±Ø®ØµØ©:</strong> 1561365</li>
    <li><strong>Ø§Ù„Ù†Ø´Ø§Ø· Ø§Ù„Ù…Ø±Ø®Øµ:</strong> Ù…Ø¬Ù…Ø¹ Ù„Ù„ØªØ¹Ø§Ù…Ù„ Ø§Ù„Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ / Ø³ÙˆÙ‚ Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ</li>
    <li><strong>Ø§Ù„Ø´ÙƒÙ„ Ø§Ù„Ù‚Ø§Ù†ÙˆÙ†ÙŠ:</strong> Ù…Ø¤Ø³Ø³Ø© ÙØ±Ø¯ÙŠØ©</li>
    <li><strong>Ø§Ù„Ù†Ø·Ø§Ù‚ Ø§Ù„Ø¬ØºØ±Ø§ÙÙŠ:</strong> Ø¥Ù…Ø§Ø±Ø© Ø¯Ø¨ÙŠ â€“ Ø¯ÙˆÙ„Ø© Ø§Ù„Ø¥Ù…Ø§Ø±Ø§Øª Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© Ø§Ù„Ù…ØªØ­Ø¯Ø©</li>
  </ul>

  <p className="mt-2">
  ØªØ¹Ù…Ù„ PTfinderNow ÙƒÙ…Ù†ØµØ© Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠØ© ÙÙ‚Ø·ØŒ ÙˆÙ„Ø§ ØªÙ…ØªÙ„Ùƒ Ø£Ùˆ ØªØ¯ÙŠØ± Ù…ÙƒØ§ØªØ¨ ÙØ¹Ù„ÙŠØ© Ø£Ùˆ Ù…Ø±Ø§ÙÙ‚
  ØªØ¯Ø±ÙŠØ¨ÙŠØ©.
</p>


          </p>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            {/* Ø§Ø®ØªÙŠØ§Ø±ÙŠ: ÙŠÙ…ÙƒÙ†Ùƒ Ø¥Ø¶Ø§ÙØ© Ø±Ù‚Ù… Ø§Ù„Ø±Ø®ØµØ© Ø¥Ø°Ø§ ØªÙˆÙØ± */}
            {/* ÙŠÙ…ÙƒÙ† ØªÙˆÙÙŠØ± ØªÙØ§ØµÙŠÙ„ Ø§Ù„Ø±Ø®ØµØ© Ø¹Ù†Ø¯ Ø§Ù„Ø·Ù„Ø¨ Ø£Ùˆ Ø¹Ø±Ø¶Ù‡Ø§ Ø¯Ø§Ø®Ù„ Ø§Ù„Ù…Ù†ØµØ©. */}
          </p>
        </div>

        {/* 3. Ø·Ø¨ÙŠØ¹Ø© Ø§Ù„Ù…Ù†ØµØ© */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">3. Ø·Ø¨ÙŠØ¹Ø© Ø§Ù„Ù…Ù†ØµØ©</h2>
          <p>
            PTfinderNow Ù‡ÙŠ Ù…Ù†ØµØ© ØªÙ‚Ù†ÙŠØ© ØªØ¹Ù…Ù„ ÙƒØ³ÙˆÙ‚ Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ ÙŠØ±Ø¨Ø· Ø§Ù„Ø¹Ù…Ù„Ø§Ø¡ Ø¨Ø®Ø¨Ø±Ø§Ø¡
            Ù…Ø³ØªÙ‚Ù„ÙŠÙ† ÙÙŠ ØªØ®ØµØµØ§Øª Ù…ØªØ¹Ø¯Ø¯Ø©ØŒ Ø¨Ù…Ø§ ÙÙŠ Ø°Ù„Ùƒ Ø¹Ù„Ù‰ Ø³Ø¨ÙŠÙ„ Ø§Ù„Ù…Ø«Ø§Ù„ Ù„Ø§ Ø§Ù„Ø­ØµØ±:
            Ø§Ù„Ø±ÙŠØ§Ø¶Ø© ÙˆØ§Ù„Ù„ÙŠØ§Ù‚Ø© Ø§Ù„Ø¨Ø¯Ù†ÙŠØ©ØŒ Ø§Ù„Ù„ØºØ§ØªØŒ Ø§Ù„ØªØ¹Ù„ÙŠÙ…ØŒ Ø§Ù„Ù…ÙˆØ§Ø¯ Ø§Ù„Ø¯Ø±Ø§Ø³ÙŠØ©ØŒ Ø§Ù„Ù…ÙˆØ³ÙŠÙ‚Ù‰ØŒ
            Ø§Ù„ÙÙ†ÙˆÙ†ØŒ Ø§Ù„Ø¨Ø±Ù…Ø¬Ø©ØŒ Ø§Ù„Ø£Ø¹Ù…Ø§Ù„ØŒ Ø§Ù„ØªØµÙˆÙŠØ±ØŒ Ø§Ù„Ø·Ø¨Ø®ØŒ Ø§Ù„ØªØ¯Ø±ÙŠØ¨ Ø§Ù„Ø­ÙŠØ§ØªÙŠØŒ ØªØ·ÙˆÙŠØ±
            Ø§Ù„Ø°Ø§ØªØŒ Ø§Ù„Ø¬Ù…Ø§Ù„ØŒ ÙˆØ®Ø¯Ù…Ø§Øª Ù†Ù…Ø· Ø§Ù„Ø­ÙŠØ§Ø©.
          </p>
          <p className="mt-2">
            Ù„Ø§ ØªÙ‚ÙˆÙ… PTfinderNow Ø¨ØªÙˆØ¸ÙŠÙ Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ØŒ ÙˆÙ„Ø§ ØªØ¹Ù…Ù„ ÙƒÙˆÙƒÙŠÙ„ Ø¹Ù†Ù‡Ù…ØŒ ÙˆÙ„Ø§ ØªÙ‚Ø¯Ù…
            Ø§Ù„Ø®Ø¯Ù…Ø§Øª Ø¨Ø´ÙƒÙ„ Ù…Ø¨Ø§Ø´Ø±. ÙŠØ¹Ù…Ù„ Ø¬Ù…ÙŠØ¹ Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ Ø¨Ø´ÙƒÙ„ Ù…Ø³ØªÙ‚Ù„ ÙˆØ¹Ù„Ù‰ Ù…Ø³Ø¤ÙˆÙ„ÙŠØªÙ‡Ù…
            Ø§Ù„ÙƒØ§Ù…Ù„Ø©.
          </p>
        </div>

        {/* 4. Ø­Ø³Ø§Ø¨Ø§Øª Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ ÙˆØ§Ù„Ø§Ø´ØªØ±Ø§ÙƒØ§Øª */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            4. Ø­Ø³Ø§Ø¨Ø§Øª Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ ÙˆØ§Ù„Ø§Ø´ØªØ±Ø§ÙƒØ§Øª
          </h2>
          <p>
            ØªÙˆÙØ± PTfinderNow Ø®Ø·Ø· Ø§Ø´ØªØ±Ø§Ùƒ Ù„Ù„Ø®Ø¨Ø±Ø§Ø¡ Ù„Ù„ÙˆØµÙˆÙ„ Ø¥Ù„Ù‰ Ù…ÙŠØ²Ø§Øª Ø§Ù„Ù…Ù†ØµØ©. Ù‚Ø¯ ØªØ´Ù…Ù„
            Ø§Ù„Ø®Ø·Ø· Ø§Ù„Ø­Ø§Ù„ÙŠØ©ØŒ Ø¹Ù„Ù‰ Ø³Ø¨ÙŠÙ„ Ø§Ù„Ù…Ø«Ø§Ù„ Ù„Ø§ Ø§Ù„Ø­ØµØ±:
          </p>
          <ul className="list-disc pr-6 mt-2">
            <li>Ø§Ù„Ø®Ø·Ø© Ø§Ù„Ø£Ø³Ø§Ø³ÙŠØ©: 49 Ø¯Ø±Ù‡Ù… Ø¥Ù…Ø§Ø±Ø§ØªÙŠ Ø´Ù‡Ø±ÙŠÙ‹Ø§</li>
            <li>Ø§Ù„Ø®Ø·Ø© Ø§Ù„Ø§Ø­ØªØ±Ø§ÙÙŠØ©: 149 Ø¯Ø±Ù‡Ù… Ø¥Ù…Ø§Ø±Ø§ØªÙŠ Ø´Ù‡Ø±ÙŠÙ‹Ø§</li>
          </ul>
          <p className="mt-2">
            Ø®Ù„Ø§Ù„ Ù…Ø±Ø­Ù„Ø© Ø§Ù„Ø¥Ø·Ù„Ø§Ù‚ Ø§Ù„Ù…Ø¨Ø¯Ø¦ÙŠØŒ Ù‚Ø¯ ÙŠØ­ØµÙ„ Ø¨Ø¹Ø¶ Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ Ø§Ù„Ù…Ø®ØªØ§Ø±ÙŠÙ† Ø¹Ù„Ù‰ ÙˆØµÙˆÙ„
            Ù…Ø¬Ø§Ù†ÙŠ Ø¥Ù„Ù‰ Ø§Ù„Ø®Ø·Ø© Ø§Ù„Ø§Ø­ØªØ±Ø§ÙÙŠØ© Ù„Ù…Ø¯Ø© ØªØµÙ„ Ø¥Ù„Ù‰ Ø³ØªØ© (6) Ø£Ø´Ù‡Ø±.
          </p>
          <p className="mt-2">
            ØªØ­ØªÙØ¸ PTfinderNow Ø¨Ø§Ù„Ø­Ù‚ ÙÙŠ ØªØ¹Ø¯ÙŠÙ„ Ø§Ù„Ø£Ø³Ø¹Ø§Ø± Ø£Ùˆ Ø§Ù„Ø®Ø·Ø· Ø£Ùˆ Ø§Ù„Ù…ÙŠØ²Ø§Øª Ø£Ùˆ
            Ø§Ù„Ø¹Ø±ÙˆØ¶ Ø§Ù„ØªØ±ÙˆÙŠØ¬ÙŠØ© Ø£Ùˆ Ø§Ù„ÙØªØ±Ø§Øª Ø§Ù„Ù…Ø¬Ø§Ù†ÙŠØ© ÙÙŠ Ø£ÙŠ ÙˆÙ‚Øª. ÙŠØªÙ… ØªØ­ØµÙŠÙ„ Ø±Ø³ÙˆÙ…
            Ø§Ù„Ø§Ø´ØªØ±Ø§Ùƒ Ù…Ù‚Ø§Ø¨Ù„ Ø§Ù„ÙˆØµÙˆÙ„ Ø¥Ù„Ù‰ Ø§Ù„Ù…Ù†ØµØ© ÙÙ‚Ø· ÙˆÙ„Ø§ ØªØ¶Ù…Ù† Ø§Ù„Ø­Ø¬ÙˆØ²Ø§Øª Ø£Ùˆ Ø§Ù„Ø¯Ø®Ù„ Ø£Ùˆ
            Ø§Ù„Ø¸Ù‡ÙˆØ± Ø£Ùˆ Ø§Ù„Ù†ØªØ§Ø¦Ø¬.
          </p>
          <p className="mt-2">
            ÙŠØªØ­Ù…Ù„ Ø§Ù„Ø®Ø¨ÙŠØ± Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø£ÙŠ Ø¶Ø±Ø§Ø¦Ø¨ Ø£Ùˆ Ø±Ø³ÙˆÙ… Ø­ÙƒÙˆÙ…ÙŠØ© Ø£Ùˆ Ø¶Ø±ÙŠØ¨Ø© Ù‚ÙŠÙ…Ø© Ù…Ø¶Ø§ÙØ© Ø¥Ù†
            ÙˆØ¬Ø¯Øª ÙˆØ§Ù„Ù…ØªØ¹Ù„Ù‚Ø© Ø¨Ø®Ø¯Ù…Ø§ØªÙ‡ Ø£Ùˆ Ø£Ø±Ø¨Ø§Ø­Ù‡.
          </p>
        </div>

        {/* 5. Ø§Ù„ØªØ­Ù‚Ù‚ Ù…Ù† Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ ÙˆØ§Ù„ØªÙ‚ÙŠÙŠÙ…Ø§Øª */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            5. Ø§Ù„ØªØ­Ù‚Ù‚ Ù…Ù† Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ ÙˆØ§Ù„ØªÙ‚ÙŠÙŠÙ…Ø§Øª
          </h2>
          <p>
            Ù„Ø§ ØªÙ‚ÙˆÙ… PTfinderNow Ø¨Ø§Ù„ØªØ­Ù‚Ù‚ Ù…Ù† Ù‡ÙˆÙŠØ© Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ Ø£Ùˆ Ù…Ø¤Ù‡Ù„Ø§ØªÙ‡Ù… Ø£Ùˆ Ø´Ù‡Ø§Ø¯Ø§ØªÙ‡Ù…
            Ø£Ùˆ ØªØ±Ø§Ø®ÙŠØµÙ‡Ù… Ø£Ùˆ Ø®Ù„ÙÙŠØ§ØªÙ‡Ù… Ø¥Ù„Ø§ Ø¥Ø°Ø§ ØªÙ… Ø§Ù„ØªØµØ±ÙŠØ­ Ø¨Ø°Ù„Ùƒ Ø¨Ø´ÙƒÙ„ ØµØ±ÙŠØ­. ÙŠØªØ­Ù…Ù„
            Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù… Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø§Ù„ØªØ­Ù‚Ù‚ Ù…Ù† Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ Ø¨Ø´ÙƒÙ„ Ù…Ø³ØªÙ‚Ù„ Ù‚Ø¨Ù„ Ø§Ù„Ø¯Ø®ÙˆÙ„ ÙÙŠ Ø£ÙŠ Ø¬Ù„Ø³Ø©.
          </p>
          <p className="mt-2">
            Ù‚Ø¯ ØªØ£ØªÙŠ Ø§Ù„Ù…Ø±Ø§Ø¬Ø¹Ø§Øª ÙˆØ§Ù„ØªÙ‚ÙŠÙŠÙ…Ø§Øª Ø§Ù„Ù…Ø¹Ø±ÙˆØ¶Ø© Ø¹Ù„Ù‰ Ø§Ù„Ù…Ù†ØµØ© Ù…Ù† Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† Ø£Ùˆ Ù…Ù†
            Ù…ØµØ§Ø¯Ø± Ø®Ø§Ø±Ø¬ÙŠØ© Ø£Ùˆ Ù…Ù† Ù…Ù†ØµØ§Øª Ø£Ø®Ø±Ù‰ Ù…Ø«Ù„ Google. ÙˆØ¹Ù„Ù‰ Ø§Ù„Ø±ØºÙ… Ù…Ù† Ø£Ù† Ø¨Ø¹Ø¶
            Ø§Ù„Ù…Ø±Ø§Ø¬Ø¹Ø§Øª Ù‚Ø¯ ØªÙƒÙˆÙ† Ù…ÙˆØ«Ù‚Ø©ØŒ ÙØ¥Ù† PTfinderNow Ù„Ø§ ØªØ¶Ù…Ù† Ø¯Ù‚ØªÙ‡Ø§ Ø£Ùˆ ØµØ­ØªÙ‡Ø§ Ø£Ùˆ
            Ø§ÙƒØªÙ…Ø§Ù„Ù‡Ø§.
          </p>
          <p className="mt-2">
            ØªØ¹ÙƒØ³ Ø§Ù„ØªÙ‚ÙŠÙŠÙ…Ø§Øª Ø¢Ø±Ø§Ø¡ Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† Ø§Ù„Ø´Ø®ØµÙŠØ© ÙˆÙ„Ø§ ØªÙ…Ø«Ù„ ØªØ£ÙŠÙŠØ¯Ù‹Ø§ Ù…Ù† PTfinderNow
            Ù„Ø£ÙŠ Ø®Ø¨ÙŠØ±.
          </p>
          <p className="mt-2">
            Ù„Ø§ ØªÙ‚Ø¯Ù… PTfinderNow Ø£ÙŠ Ø¶Ù…Ø§Ù†Ø§Øª ØªØªØ¹Ù„Ù‚ Ø¨Ø¬ÙˆØ¯Ø© Ø£Ùˆ Ø£Ø¯Ø§Ø¡ Ø£Ùˆ Ù…ÙˆØ«ÙˆÙ‚ÙŠØ© Ø£Ùˆ
            Ù…Ù„Ø§Ø¡Ù…Ø© Ø£ÙŠ Ø®Ø¨ÙŠØ±.
          </p>
        </div>

        {/* 6. Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ù…Ø­ØªÙˆÙ‰ ÙˆÙ…Ù„Ù Ø§Ù„Ø®Ø¨ÙŠØ± */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            6. Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ù…Ø­ØªÙˆÙ‰ ÙˆÙ…Ù„Ù Ø§Ù„Ø®Ø¨ÙŠØ±
          </h2>
          <p>
            ÙŠØªØ­Ù…Ù„ Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ Ø§Ù„Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø§Ù„ÙƒØ§Ù…Ù„Ø© Ø¹Ù† Ø¬Ù…ÙŠØ¹ Ø§Ù„Ù…Ø¹Ù„ÙˆÙ…Ø§Øª ÙˆØ§Ù„Ù…Ø­ØªÙˆÙ‰ ÙˆØ§Ù„Ø£ÙˆØµØ§Ù
            ÙˆØ§Ù„Ø£Ø³Ø¹Ø§Ø± ÙˆØ§Ù„Ù…Ø¤Ù‡Ù„Ø§Øª ÙˆØ§Ù„ÙˆØ³Ø§Ø¦Ø· ÙˆØ§Ù„Ø§Ø¯Ø¹Ø§Ø¡Ø§Øª Ø§Ù„Ù…Ù†Ø´ÙˆØ±Ø© ÙÙŠ Ù…Ù„ÙØ§ØªÙ‡Ù… Ø§Ù„Ø´Ø®ØµÙŠØ© Ø£Ùˆ
            Ø§Ù„ØªÙŠ ØªØªÙ… Ù…Ø´Ø§Ø±ÙƒØªÙ‡Ø§ Ù…Ø¹ Ø§Ù„Ø¹Ù…Ù„Ø§Ø¡.
          </p>
          <p className="mt-2">
            ÙŠÙÙ…Ù†Ø¹ Ø¹Ù„Ù‰ Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ ØªÙ‚Ø¯ÙŠÙ… Ù…Ø¹Ù„ÙˆÙ…Ø§Øª ÙƒØ§Ø°Ø¨Ø© Ø£Ùˆ Ù…Ø¶Ù„Ù„Ø© Ø£Ùˆ Ø§Ø­ØªÙŠØ§Ù„ÙŠØ© Ø£Ùˆ ØºÙŠØ±
            Ù‚Ø§Ù†ÙˆÙ†ÙŠØ©. ÙˆÙ„Ø§ ØªØªØ­Ù…Ù„ PTfinderNow Ø£ÙŠ Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ù‚Ø§Ù†ÙˆÙ†ÙŠØ© Ø¹Ù† Ø£ÙŠ Ù…Ø­ØªÙˆÙ‰ ØºÙŠØ±
            ØµØ­ÙŠØ­ Ø£Ùˆ Ù…Ø²ÙŠÙ ÙŠÙ†Ø´Ø±Ù‡ Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡.
          </p>
          <p className="mt-2">
            ØªØ­ØªÙØ¸ PTfinderNow Ø¨Ø§Ù„Ø­Ù‚ ÙÙŠ Ø¥Ø²Ø§Ù„Ø© Ø£Ùˆ ØªØ¹Ù„ÙŠÙ‚ Ø£ÙŠ Ù…Ù„Ù Ø®Ø¨ÙŠØ± Ø£Ùˆ Ù…Ø­ØªÙˆÙ‰ ÙŠÙØ´ØªØ¨Ù‡
            ÙÙŠ ÙƒÙˆÙ†Ù‡ ÙƒØ§Ø°Ø¨Ù‹Ø§ Ø£Ùˆ Ù…Ø¶Ù„Ù„Ù‹Ø§ Ø£Ùˆ Ø¶Ø§Ø±Ù‹Ø§ØŒ Ø¯ÙˆÙ† Ø¥Ø´Ø¹Ø§Ø± Ù…Ø³Ø¨Ù‚ Ø£Ùˆ Ø§Ø³ØªØ±Ø¯Ø§Ø¯ Ù…Ø§Ù„ÙŠ.
          </p>
        </div>

        {/* 7. Ø§Ù„Ù…Ù„Ù Ø§Ù„Ø¹Ø§Ù… ÙˆØ¨ÙŠØ§Ù†Ø§Øª Ø§Ù„ØªÙˆØ§ØµÙ„ */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            7. Ø§Ù„Ù…Ù„Ù Ø§Ù„Ø¹Ø§Ù… ÙˆØ¨ÙŠØ§Ù†Ø§Øª Ø§Ù„ØªÙˆØ§ØµÙ„
          </h2>
          <p>
            PTfinderNow Ù…Ù†ØµØ© Ø¹Ø§Ù…Ø© ØªØ¹Ù…Ù„ ÙƒØ³ÙˆÙ‚ Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ. Ø¹Ù†Ø¯ ØªØ³Ø¬ÙŠÙ„Ùƒ ÙƒØ®Ø¨ÙŠØ±ØŒ ÙØ¥Ù†Ùƒ ØªÙ‚Ø±
            ÙˆØªÙˆØ§ÙÙ‚ Ø¹Ù„Ù‰ Ø£Ù† Ø¨Ø¹Ø¶ Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ù…Ù„ÙÙƒ Ù‚Ø¯ ØªÙƒÙˆÙ† Ø¸Ø§Ù‡Ø±Ø© Ù„Ù„Ø¹Ø§Ù…Ø© Ù„Ù„Ø¹Ù…Ù„Ø§Ø¡ ÙˆØ§Ù„Ø²ÙˆØ§Ø±.
          </p>
          <p className="mt-2">
            ÙˆÙ‚Ø¯ ÙŠØ´Ù…Ù„ Ø°Ù„Ùƒ Ø§Ù„Ø§Ø³Ù…ØŒ Ø§Ù„ØµÙˆØ±Ø©ØŒ Ø§Ù„ÙˆØµÙØŒ Ø§Ù„ØªØ®ØµØµØŒ Ø§Ù„Ù…ÙˆÙ‚Ø¹ØŒ Ø§Ù„Ø³Ø¹Ø±ØŒ Ø§Ù„Ù…ÙˆØ§Ø¹ÙŠØ¯ØŒ
            Ø§Ù„Ù…Ø¹Ø±Ø¶ØŒ Ø§Ù„ØªÙ‚ÙŠÙŠÙ…Ø§ØªØŒ Ùˆ(Ø¥Ø°Ø§ ØªÙ… ØªÙØ¹ÙŠÙ„Ù‡Ø§) Ø¨ÙŠØ§Ù†Ø§Øª Ø§Ù„ØªÙˆØ§ØµÙ„ Ù…Ø«Ù„ Ø§Ù„Ø¨Ø±ÙŠØ¯
            Ø§Ù„Ø¥Ù„ÙƒØªØ±ÙˆÙ†ÙŠ ÙˆØ±Ù‚Ù… Ø§Ù„Ù‡Ø§ØªÙ ÙˆÙˆØ§ØªØ³Ø§Ø¨.
          </p>
          <p className="mt-2">
            ÙŠÙ‚ÙˆÙ… Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ Ø¨Ø¥Ø¯Ø®Ø§Ù„ Ø¨ÙŠØ§Ù†Ø§Øª Ø§Ù„ØªÙˆØ§ØµÙ„ Ø¨Ø¥Ø±Ø§Ø¯ØªÙ‡Ù… ÙˆÙŠÙˆØ§ÙÙ‚ÙˆÙ† Ø¹Ù„Ù‰ Ø¹Ø±Ø¶Ù‡Ø§ Ùˆ/Ø£Ùˆ
            Ù…Ø´Ø§Ø±ÙƒØªÙ‡Ø§ Ù…Ø¹ Ø§Ù„Ø¹Ù…Ù„Ø§Ø¡. Ù„Ø§ ØªØªØ­Ù…Ù„ PTfinderNow Ø£ÙŠ Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø¹Ù† Ø£ÙŠ ØªÙˆØ§ØµÙ„ Ø£Ùˆ
            Ø§ØªÙØ§Ù‚Ø§Øª Ø£Ùˆ Ù†Ø²Ø§Ø¹Ø§Øª ØªØªÙ… Ø¨Ø¹Ø¯ Ø¹Ø±Ø¶ Ø£Ùˆ Ù…Ø´Ø§Ø±ÙƒØ© Ø¨ÙŠØ§Ù†Ø§Øª Ø§Ù„ØªÙˆØ§ØµÙ„.
          </p>
        </div>

        {/* 8. Ù…Ø³Ø¤ÙˆÙ„ÙŠØ§Øª Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">8. Ù…Ø³Ø¤ÙˆÙ„ÙŠØ§Øª Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ†</h2>
          <p>
            ÙŠÙˆØ§ÙÙ‚ Ø¬Ù…ÙŠØ¹ Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† Ø¹Ù„Ù‰ ØªÙ‚Ø¯ÙŠÙ… Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ø¯Ù‚ÙŠÙ‚Ø©ØŒ ÙˆØ§Ù„ØªØµØ±Ù Ø¨Ø§Ø­ØªØ±Ø§Ù…ØŒ
            ÙˆØ§Ù„Ø§Ù„ØªØ²Ø§Ù… Ø¨Ø¬Ù…ÙŠØ¹ Ø§Ù„Ù‚ÙˆØ§Ù†ÙŠÙ† Ø§Ù„Ù…Ø¹Ù…ÙˆÙ„ Ø¨Ù‡Ø§. ÙŠÙØ­Ø¸Ø± Ø¨Ø´ÙƒÙ„ ØµØ§Ø±Ù… Ø£ÙŠ Ø³Ù„ÙˆÙƒ
            Ø§Ø­ØªÙŠØ§Ù„ÙŠ Ø£Ùˆ Ù…Ø³ÙŠØ¡ Ø£Ùˆ Ù…Ø¶Ù„Ù„ Ø£Ùˆ ØºÙŠØ± Ù‚Ø§Ù†ÙˆÙ†ÙŠ.
          </p>
        </div>

        {/* 9. Ø´Ø±Ø· Ø§Ù„Ø¹Ù…Ø± */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">9. Ø´Ø±Ø· Ø§Ù„Ø¹Ù…Ø± (Ø§Ù„Ù‚ÙØµÙ‘Ø±)</h2>
          <p>
            Ù‡Ø°Ù‡ Ø§Ù„Ù…Ù†ØµØ© Ù…Ø®ØµØµØ© Ù„Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† Ø§Ù„Ø°ÙŠÙ† ØªØ¨Ù„Øº Ø£Ø¹Ù…Ø§Ø±Ù‡Ù… 18 Ø³Ù†Ø© Ø£Ùˆ Ø£ÙƒØ«Ø±. Ø¥Ø°Ø§ ÙƒØ§Ù†
            Ø¹Ù…Ø±Ùƒ Ø£Ù‚Ù„ Ù…Ù† 18 Ø³Ù†Ø©ØŒ ÙÙŠÙØ³Ù…Ø­ Ù„Ùƒ Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù… Ø§Ù„Ù…Ù†ØµØ© ÙÙ‚Ø· Ø¨Ù…ÙˆØ§ÙÙ‚Ø© ÙˆØ¥Ø´Ø±Ø§Ù ÙˆÙ„ÙŠ
            Ø§Ù„Ø£Ù…Ø± Ø£Ùˆ Ø§Ù„ÙˆØµÙŠ Ø§Ù„Ù‚Ø§Ù†ÙˆÙ†ÙŠ.
          </p>
          <p className="mt-2">
            ÙŠØ¬Ø¨ Ø¹Ù„Ù‰ Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ Ø¹Ø¯Ù… ØªÙ‚Ø¯ÙŠÙ… Ø®Ø¯Ù…Ø§Øª Ù„Ù„Ù‚ÙØµÙ‘Ø± Ø¯ÙˆÙ† Ø§Ù„ØªØ£ÙƒØ¯ Ù…Ù† ÙˆØ¬ÙˆØ¯ Ù…ÙˆØ§ÙÙ‚Ø© ÙˆÙ„ÙŠ
            Ø§Ù„Ø£Ù…Ø± Ø¹Ù†Ø¯ Ø§Ù„Ø­Ø§Ø¬Ø© ÙˆØ§Ù„Ø§Ù„ØªØ²Ø§Ù… Ø¨Ø¬Ù…ÙŠØ¹ Ø§Ù„Ù‚ÙˆØ§Ù†ÙŠÙ† Ø§Ù„Ù…ØªØ¹Ù„Ù‚Ø© Ø¨Ø­Ù…Ø§ÙŠØ© Ø§Ù„Ø·ÙÙ„. Ù„Ø§
            ØªØªØ­Ù…Ù„ PTfinderNow Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø§Ù„ØªØ­Ù‚Ù‚ Ù…Ù† Ø¹Ù…Ø± Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù… Ø£Ùˆ Ø§Ù„Ø­ØµÙˆÙ„ Ø¹Ù„Ù‰ Ù…ÙˆØ§ÙÙ‚Ø©
            ÙˆÙ„ÙŠ Ø§Ù„Ø£Ù…Ø±.
          </p>
        </div>

        {/* 10. Ø§Ù„Ø¬Ù„Ø³Ø§Øª */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            10. Ø§Ù„Ø¬Ù„Ø³Ø§Øª (Ø­Ø¶ÙˆØ±ÙŠØ© Ø£Ùˆ Ø¹Ø¨Ø± Ø§Ù„Ø¥Ù†ØªØ±Ù†Øª)
          </h2>
          <p>
            ÙŠÙ…ÙƒÙ† Ø£Ù† ØªÙƒÙˆÙ† Ø§Ù„Ø¬Ù„Ø³Ø§Øª Ø­Ø¶ÙˆØ±ÙŠØ© Ø£Ùˆ Ø¹Ø¨Ø± Ø§Ù„Ø¥Ù†ØªØ±Ù†Øª. ÙŠØªÙ… Ø§Ù„Ø§ØªÙØ§Ù‚ Ø¹Ù„Ù‰ Ù†ÙˆØ¹
            Ø§Ù„Ø¬Ù„Ø³Ø© ÙˆÙ…ÙƒØ§Ù†Ù‡Ø§ ÙˆÙ…Ø¯ØªÙ‡Ø§ ÙˆØªØ³Ø¹ÙŠØ±Ù‡Ø§ ÙˆØ´Ø±ÙˆØ·Ù‡Ø§ Ø­ØµØ±ÙŠÙ‹Ø§ Ø¨ÙŠÙ† Ø§Ù„Ø¹Ù…ÙŠÙ„ ÙˆØ§Ù„Ø®Ø¨ÙŠØ±.
          </p>
          <p className="mt-2">
            Ù„Ø§ ØªØ¹ØªØ¨Ø± PTfinderNow Ø·Ø±ÙÙ‹Ø§ ÙÙŠ Ø£ÙŠ Ø§ØªÙØ§Ù‚ØŒ ÙˆÙ„Ø§ ØªØ´Ø±Ù Ø£Ùˆ ØªØªØ­ÙƒÙ… Ø£Ùˆ ØªØ¶Ù…Ù†
            ÙƒÙŠÙÙŠØ© ØªÙ‚Ø¯ÙŠÙ… Ø§Ù„Ø¬Ù„Ø³Ø§Øª.
          </p>
        </div>

        {/* 11. Ø§Ù„Ø¥Ù‚Ø±Ø§Ø± Ø¨Ø§Ù„Ù…Ø®Ø§Ø·Ø± */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">11. Ø§Ù„Ø¥Ù‚Ø±Ø§Ø± Ø¨Ø§Ù„Ù…Ø®Ø§Ø·Ø±</h2>
          <p>
            Ù‚Ø¯ ØªÙ†Ø·ÙˆÙŠ Ø¨Ø¹Ø¶ Ø§Ù„Ø®Ø¯Ù…Ø§Øª Ø§Ù„Ù…Ù‚Ø¯Ù…Ø© Ø¹Ø¨Ø± Ø§Ù„Ù…Ù†ØµØ© Ø¹Ù„Ù‰ Ù…Ø®Ø§Ø·Ø± Ø¬Ø³Ø¯ÙŠØ© Ø£Ùˆ Ù†ÙØ³ÙŠØ© Ø£Ùˆ
            Ù…Ø§Ù„ÙŠØ© Ø£Ùˆ Ø´Ø®ØµÙŠØ©ØŒ Ø¨Ù…Ø§ ÙÙŠ Ø°Ù„Ùƒ Ø¹Ù„Ù‰ Ø³Ø¨ÙŠÙ„ Ø§Ù„Ù…Ø«Ø§Ù„ Ù„Ø§ Ø§Ù„Ø­ØµØ±: Ø§Ù„ØªØ¯Ø±ÙŠØ¨ Ø§Ù„Ø±ÙŠØ§Ø¶ÙŠØŒ
            Ø£Ù†Ø´Ø·Ø© Ø§Ù„Ù„ÙŠØ§Ù‚Ø© Ø§Ù„Ø¨Ø¯Ù†ÙŠØ©ØŒ Ø§Ù„Ø¥Ø±Ø´Ø§Ø¯ Ø§Ù„ØºØ°Ø§Ø¦ÙŠØŒ Ø§Ù„ØªØ¯Ø±ÙŠØ¨ Ø§Ù„Ø­ÙŠØ§ØªÙŠØŒ Ø£Ùˆ Ø§Ù„Ø§Ø³ØªØ´Ø§Ø±Ø§Øª
            Ø§Ù„ØªØ¬Ø§Ø±ÙŠØ©.
          </p>
          <p className="mt-2">
            Ø¨Ø§Ø³ØªØ®Ø¯Ø§Ù…Ùƒ Ù„Ù…Ù†ØµØ© PTfinderNowØŒ ÙØ¥Ù†Ùƒ ØªÙ‚Ø± Ø¨Ø§Ù„Ù…Ø´Ø§Ø±ÙƒØ© Ø·ÙˆØ¹Ù‹Ø§ ÙˆØªØªØ­Ù…Ù„ ÙƒØ§Ù…Ù„
            Ø§Ù„Ù…Ø³Ø¤ÙˆÙ„ÙŠØ©ØŒ ÙˆØªØ¤ÙƒØ¯ Ø£Ù†Ùƒ Ù„Ø§Ø¦Ù‚ ØµØ­ÙŠÙ‹Ø§ ÙˆØ°Ù‡Ù†ÙŠÙ‹Ø§ Ø­ÙŠØ«Ù…Ø§ ÙŠÙ†Ø·Ø¨Ù‚ Ø°Ù„Ùƒ.
          </p>
        </div>

        {/* 12. Ø¹Ø¯Ù… ØªÙ‚Ø¯ÙŠÙ… Ø§Ø³ØªØ´Ø§Ø±Ø§Øª Ù…Ù‡Ù†ÙŠØ© */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            12. Ø¹Ø¯Ù… ØªÙ‚Ø¯ÙŠÙ… Ø§Ø³ØªØ´Ø§Ø±Ø§Øª Ù…Ù‡Ù†ÙŠØ©
          </h2>
          <p>
            ÙŠÙ‚Ø¯Ù… Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡ Ø®Ø¯Ù…Ø§Øª ØªØ¹Ù„ÙŠÙ…ÙŠØ© ÙˆÙ…Ø¹Ù„ÙˆÙ…Ø§ØªÙŠØ© ÙÙ‚Ø·. Ù„Ø§ ØªÙ‚Ø¯Ù… PTfinderNow Ø£ÙŠ
            Ø§Ø³ØªØ´Ø§Ø±Ø§Øª Ø·Ø¨ÙŠØ© Ø£Ùˆ Ù†ÙØ³ÙŠØ© Ø£Ùˆ Ù‚Ø§Ù†ÙˆÙ†ÙŠØ© Ø£Ùˆ Ù…Ø§Ù„ÙŠØ©. ÙŠØ¬Ø¨ Ø¹Ù„Ù‰ Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ†
            Ø§Ø³ØªØ´Ø§Ø±Ø© Ù…Ø®ØªØµÙŠÙ† Ù…Ø¤Ù‡Ù„ÙŠÙ† Ø¹Ù†Ø¯ Ø§Ù„Ø­Ø§Ø¬Ø©.
          </p>
        </div>

        {/* 13. Ù‡Ø¯Ø§ÙŠØ§ Ø§Ù„Ø´ÙƒØ± */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">13. Ù‡Ø¯Ø§ÙŠØ§ Ø§Ù„Ø´ÙƒØ±</h2>
          <p>
            Ù‚Ø¯ ØªØªÙŠØ­ PTfinderNow Ù„Ù„Ø¹Ù…Ù„Ø§Ø¡ Ø¥Ø±Ø³Ø§Ù„ â€œÙ‡Ø¯Ø§ÙŠØ§ Ø´ÙƒØ±â€ Ø§Ø®ØªÙŠØ§Ø±ÙŠØ© Ù„Ù„Ø®Ø¨Ø±Ø§Ø¡ ÙƒØªØ¹Ø¨ÙŠØ±
            Ø¹Ù† Ø§Ù„ØªÙ‚Ø¯ÙŠØ±.
          </p>
          <p className="mt-2">
            Ù‡Ø¯Ø§ÙŠØ§ Ø§Ù„Ø´ÙƒØ± Ø§Ø®ØªÙŠØ§Ø±ÙŠØ© ÙˆØºÙŠØ± Ù‚Ø§Ø¨Ù„Ø© Ù„Ù„Ø§Ø³ØªØ±Ø¯Ø§Ø¯ØŒ ÙˆÙ„Ø§ ØªÙØ¹Ø¯ Ø±ÙˆØ§ØªØ¨ Ø£Ùˆ Ø£Ø¬ÙˆØ±ØŒ
            ÙˆÙ„Ø§ ØªØ¶Ù…Ù† Ù†ØªØ§Ø¦Ø¬ Ø£Ùˆ Ø§Ø³ØªÙ…Ø±Ø§Ø± Ø§Ù„Ø®Ø¯Ù…Ø©.
          </p>
          <p className="mt-2">
            Ù„Ø§ ØªÙÙ†Ø´Ø¦ Ù‡Ø¯Ø§ÙŠØ§ Ø§Ù„Ø´ÙƒØ± Ø£ÙŠ Ø¹Ù„Ø§Ù‚Ø© Ø¹Ù…Ù„ Ø£Ùˆ Ø´Ø±Ø§ÙƒØ© Ø£Ùˆ ÙˆÙƒØ§Ù„Ø© Ø¨ÙŠÙ† PTfinderNow
            ÙˆØ§Ù„Ø®Ø¨Ø±Ø§Ø¡.
          </p>
          <p className="mt-2">
            ØªØªÙ… Ù…Ø¹Ø§Ù„Ø¬Ø© Ù‡Ø¯Ø§ÙŠØ§ Ø§Ù„Ø´ÙƒØ± (Ø¥Ù† ØªÙ… ØªÙØ¹ÙŠÙ„Ù‡Ø§) Ø¹Ø¨Ø± Ù…Ø²ÙˆØ¯ÙŠ Ø®Ø¯Ù…Ø§Øª Ø¯ÙØ¹ Ø®Ø§Ø±Ø¬ÙŠÙŠÙ† Ù…Ø«Ù„
            StripeØŒ ÙˆØªØ®Ø¶Ø¹ Ù„Ø´Ø±ÙˆØ·Ù‡Ù… ÙˆÙ…ØªØ·Ù„Ø¨Ø§Øª Ø§Ù„Ø§Ù…ØªØ«Ø§Ù„ ÙˆØ§Ù„ØªØ­Ù‚Ù‚ ÙˆØ§Ù„Ù…ÙˆØ§ÙÙ‚Ø©. Ù„Ø§ ØªØªØ­ÙƒÙ…
            PTfinderNow ÙˆÙ„Ø§ ØªØ¶Ù…Ù† Ù…ÙˆØ§ÙÙ‚Ø§Øª Ù…Ø²ÙˆØ¯ Ø§Ù„Ø¯ÙØ¹ Ø£Ùˆ Ù‚Ø±Ø§Ø±Ø§Øª Ø§Ù„ØªØ­ÙˆÙŠÙ„ØŒ ÙˆÙ„Ø§ ØªØªØ­Ù…Ù„
            Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø£ÙŠ ØªØ£Ø®ÙŠØ± Ø£Ùˆ Ø±ÙØ¶ Ø£Ùˆ Ø¥Ù„ØºØ§Ø¡ Ø£Ùˆ Ø§Ø³ØªØ±Ø¬Ø§Ø¹ (Chargeback) Ø£Ùˆ Ù‚Ø±Ø§Ø±Ø§Øª
            ØªØªØ¹Ù„Ù‚ Ø¨ØªØ­ÙˆÙŠÙ„ Ø§Ù„Ø£Ù…ÙˆØ§Ù„.
          </p>
          <ul className="list-disc pr-6 mt-2">
            <li>80Ùª Ù„Ù„Ø®Ø¨ÙŠØ±</li>
            <li>20Ùª Ø±Ø³ÙˆÙ… Ø®Ø¯Ù…Ø© Ù„Ù„Ù…Ù†ØµØ© (ØªØ´Ù…Ù„ Ø±Ø³ÙˆÙ… Ù…Ø¹Ø§Ù„Ø¬Ø© Ø§Ù„Ø¯ÙØ¹ Ù…Ø«Ù„ Stripe)</li>
          </ul>
        </div>

        {/* 14. Ø§Ù„Ù…Ø¯ÙÙˆØ¹Ø§Øª ÙˆØ§Ù„Ø¥Ù„ØºØ§Ø¡Ø§Øª ÙˆØ§Ù„Ø§Ø³ØªØ±Ø¯Ø§Ø¯ */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            14. Ø§Ù„Ù…Ø¯ÙÙˆØ¹Ø§Øª ÙˆØ§Ù„Ø¥Ù„ØºØ§Ø¡Ø§Øª ÙˆØ§Ù„Ø§Ø³ØªØ±Ø¯Ø§Ø¯
          </h2>
          <p>
            Ù„Ø§ ØªÙ‚ÙˆÙ… PTfinderNow Ø­Ø§Ù„ÙŠÙ‹Ø§ Ø¨Ù…Ø¹Ø§Ù„Ø¬Ø© Ù…Ø¯ÙÙˆØ¹Ø§Øª Ø§Ù„Ø¬Ù„Ø³Ø§Øª Ø¨ÙŠÙ† Ø§Ù„Ø¹Ù…Ù„Ø§Ø¡
            ÙˆØ§Ù„Ø®Ø¨Ø±Ø§Ø¡. ÙŠØ¬Ø¨ Ø§Ù„ØªØ¹Ø§Ù…Ù„ Ù…Ø¹ Ø£ÙŠ Ù…Ø¯ÙÙˆØ¹Ø§Øª Ø£Ùˆ Ø¥Ù„ØºØ§Ø¡Ø§Øª Ø£Ùˆ Ø·Ù„Ø¨Ø§Øª Ø§Ø³ØªØ±Ø¯Ø§Ø¯
            Ù…ØªØ¹Ù„Ù‚Ø© Ø¨Ø§Ù„Ø¬Ù„Ø³Ø§Øª Ù…Ø¨Ø§Ø´Ø±Ø© Ø¨ÙŠÙ† Ø§Ù„Ø·Ø±ÙÙŠÙ†.
          </p>
          <p className="mt-2">
            Ù‚Ø¯ ØªÙ‚Ø¯Ù… PTfinderNow Ø£Ù†Ø¸Ù…Ø© Ø¯ÙØ¹ Ø¯Ø§Ø®Ù„ Ø§Ù„Ù…Ù†ØµØ© Ù…Ø³ØªÙ‚Ø¨Ù„Ù‹Ø§ ÙˆÙÙ‚Ù‹Ø§ Ù„Ø´Ø±ÙˆØ· Ù…Ø­Ø¯Ø«Ø©
            ÙˆØ§Ù„Ù‚ÙˆØ§Ù†ÙŠÙ† Ø§Ù„Ù…Ø¹Ù…ÙˆÙ„ Ø¨Ù‡Ø§.
          </p>
          <p className="mt-2">
            Ø±Ø³ÙˆÙ… Ø§Ù„Ø§Ø´ØªØ±Ø§Ùƒ Ø§Ù„Ù…Ø¯ÙÙˆØ¹Ø© Ù„Ù€ PTfinderNow ØºÙŠØ± Ù‚Ø§Ø¨Ù„Ø© Ù„Ù„Ø§Ø³ØªØ±Ø¯Ø§Ø¯ØŒ Ø¥Ù„Ø§ Ø¥Ø°Ø§
            ØªØ·Ù„Ø¨ Ø§Ù„Ù‚Ø§Ù†ÙˆÙ† Ø§Ù„Ù…Ø¹Ù…ÙˆÙ„ Ø¨Ù‡ Ø®Ù„Ø§Ù Ø°Ù„Ùƒ.
          </p>
        </div>

        {/* 15. Ø§Ù„Ù…Ø´Ø§ÙƒÙ„ Ø§Ù„ØªÙ‚Ù†ÙŠØ© ÙˆØªÙˆÙØ± Ø§Ù„Ø®Ø¯Ù…Ø© */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            15. Ø§Ù„Ù…Ø´Ø§ÙƒÙ„ Ø§Ù„ØªÙ‚Ù†ÙŠØ© ÙˆØªÙˆÙØ± Ø§Ù„Ø®Ø¯Ù…Ø©
          </h2>
          <p>
            Ù‚Ø¯ ØªÙˆØ§Ø¬Ù‡ PTfinderNow Ø£Ø®Ø·Ø§Ø¡ ØªÙ‚Ù†ÙŠØ© Ø£Ùˆ Ø£Ø¹Ø·Ø§Ù„ Ø£Ùˆ ØªÙˆÙ‚ÙÙ‹Ø§ Ù…Ø¤Ù‚ØªÙ‹Ø§ Ù„Ù„ØµÙŠØ§Ù†Ø© Ø£Ùˆ
            ØªØ£Ø®ÙŠØ±Ø§Øª Ø£Ùˆ Ø§Ù†Ù‚Ø·Ø§Ø¹Ø§Øª Ù…Ø¤Ù‚ØªØ© ÙÙŠ Ø§Ù„Ø®Ø¯Ù…Ø©.
          </p>
          <p className="mt-2">
            Ù„Ø§ ÙŠØªÙ… ØªÙ‚Ø¯ÙŠÙ… Ø£ÙŠ Ø§Ø³ØªØ±Ø¯Ø§Ø¯ Ù…Ø§Ù„ÙŠ Ø¨Ø³Ø¨Ø¨ Ø§Ù„Ø£Ø¹Ø·Ø§Ù„ Ø£Ùˆ Ø§Ù„Ø£Ø®Ø·Ø§Ø¡ Ø£Ùˆ Ø§Ù„Ù…Ø´Ø§ÙƒÙ„
            Ø§Ù„ØªÙ‚Ù†ÙŠØ©. ÙˆÙŠÙˆØ§ÙÙ‚ Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙˆÙ† Ø¹Ù„Ù‰ Ø§Ù„ØªØ­Ù„ÙŠ Ø¨Ø§Ù„ØµØ¨Ø± ÙˆØ§Ù„ØªØµØ±Ù Ø¨Ø´ÙƒÙ„ Ù…Ø¹Ù‚ÙˆÙ„ Ø¥Ù„Ù‰
            Ø­ÙŠÙ† Ø­Ù„ Ù‡Ø°Ù‡ Ø§Ù„Ù…Ø´Ø§ÙƒÙ„.
          </p>
        </div>

        {/* 16. Ø§Ù„Ø³Ù„ÙˆÙƒ Ø§Ù„Ù…Ø­Ø¸ÙˆØ± */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">16. Ø§Ù„Ø³Ù„ÙˆÙƒ Ø§Ù„Ù…Ø­Ø¸ÙˆØ±</h2>
          <p>
            ÙŠØ¬Ø¨ Ø¹Ù„Ù‰ Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† Ø¹Ø¯Ù… Ù†Ø´Ø± Ù…Ø­ØªÙˆÙ‰ ØºÙŠØ± Ù‚Ø§Ù†ÙˆÙ†ÙŠØŒ Ø£Ùˆ Ø§Ù†ØªØ­Ø§Ù„ Ø´Ø®ØµÙŠØ© Ø§Ù„ØºÙŠØ±ØŒ
            Ø£Ùˆ Ø§Ù„ØªÙ„Ø§Ø¹Ø¨ Ø¨Ù…ÙŠØ²Ø§Øª Ø§Ù„Ù…Ù†ØµØ©ØŒ Ø£Ùˆ Ø§Ù„Ø¥Ø¶Ø±Ø§Ø± Ø¨Ù†Ø²Ø§Ù‡Ø© Ø§Ù„Ø³ÙˆÙ‚. ÙˆÙ‚Ø¯ ÙŠØ¤Ø¯ÙŠ Ø°Ù„Ùƒ Ø¥Ù„Ù‰
            Ø§Ù„Ø¥ÙŠÙ‚Ø§Ù Ø§Ù„ÙÙˆØ±ÙŠ Ø£Ùˆ Ø§Ù„Ø¥Ø²Ø§Ù„Ø© Ø§Ù„Ø¯Ø§Ø¦Ù…Ø©.
          </p>
        </div>

        {/* 17. Ø¥Ø®Ù„Ø§Ø¡ Ø§Ù„Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø¹Ù† Ø§Ù„Ø¶Ù…Ø§Ù†Ø§Øª */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            17. Ø¥Ø®Ù„Ø§Ø¡ Ø§Ù„Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø¹Ù† Ø§Ù„Ø¶Ù…Ø§Ù†Ø§Øª
          </h2>
          <p>
            ÙŠØªÙ… ØªÙˆÙÙŠØ± PTfinderNow Ø¹Ù„Ù‰ Ø£Ø³Ø§Ø³ â€œÙƒÙ…Ø§ Ù‡Ùˆâ€ Ùˆâ€œØ­Ø³Ø¨ Ø§Ù„ØªÙˆÙØ±â€. ÙˆÙ„Ø§ Ù†Ø¶Ù…Ù† ØªÙˆÙØ±
            Ø§Ù„Ø®Ø¯Ù…Ø© Ø£Ùˆ Ø¯Ù‚ØªÙ‡Ø§ Ø£Ùˆ Ù…ÙˆØ«ÙˆÙ‚ÙŠØªÙ‡Ø§ Ø£Ùˆ Ø§Ø³ØªÙ…Ø±Ø§Ø±ÙŠØªÙ‡Ø§ Ø¯ÙˆÙ† Ø§Ù†Ù‚Ø·Ø§Ø¹.
          </p>
        </div>

        {/* 18. ØªØ­Ø¯ÙŠØ¯ Ø§Ù„Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">18. ØªØ­Ø¯ÙŠØ¯ Ø§Ù„Ù…Ø³Ø¤ÙˆÙ„ÙŠØ©</h2>
          <p>
            Ø¥Ù„Ù‰ Ø£Ù‚ØµÙ‰ Ø­Ø¯ ÙŠØ³Ù…Ø­ Ø¨Ù‡ Ø§Ù„Ù‚Ø§Ù†ÙˆÙ†ØŒ Ù„Ø§ ØªØªØ­Ù…Ù„ PTfinderNow Ø£ÙŠ Ù…Ø³Ø¤ÙˆÙ„ÙŠØ© Ø¹Ù†
            Ø§Ù„Ø¥ØµØ§Ø¨Ø§Øª Ø£Ùˆ Ø§Ù„Ø®Ø³Ø§Ø¦Ø± Ø£Ùˆ Ø§Ù„Ù†Ø²Ø§Ø¹Ø§Øª Ø£Ùˆ Ø§Ù„Ø£Ø¹Ø·Ø§Ù„ Ø§Ù„ØªÙ‚Ù†ÙŠØ© Ø£Ùˆ ÙÙ‚Ø¯Ø§Ù† Ø§Ù„Ø¯Ø®Ù„ Ø£Ùˆ
            Ø£ÙŠ Ø£Ø¶Ø±Ø§Ø± Ù†Ø§ØªØ¬Ø© Ø¹Ù† Ø§Ø³ØªØ®Ø¯Ø§Ù… Ø§Ù„Ù…Ù†ØµØ© Ø£Ùˆ Ø®Ø¯Ù…Ø§Øª Ø§Ù„Ø®Ø¨Ø±Ø§Ø¡.
          </p>
        </div>

        {/* 19. Ø§Ù„ØªØ¹ÙˆÙŠØ¶ */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">19. Ø§Ù„ØªØ¹ÙˆÙŠØ¶</h2>
          <p>
            Ø£Ù†Øª ØªÙˆØ§ÙÙ‚ Ø¹Ù„Ù‰ ØªØ¹ÙˆÙŠØ¶ PTfinderNow ÙˆØ¥Ø¨Ø±Ø§Ø¡ Ø°Ù…ØªÙ‡Ø§ Ù…Ù† Ø£ÙŠ Ù…Ø·Ø§Ù„Ø¨Ø§Øª Ø£Ùˆ Ø£Ø¶Ø±Ø§Ø±
            Ø£Ùˆ Ø§Ù„ØªØ²Ø§Ù…Ø§Øª Ø£Ùˆ Ø¥Ø¬Ø±Ø§Ø¡Ø§Øª Ù‚Ø§Ù†ÙˆÙ†ÙŠØ© Ù†Ø§ØªØ¬Ø© Ø¹Ù† Ø§Ø³ØªØ®Ø¯Ø§Ù…Ùƒ Ù„Ù„Ù…Ù†ØµØ© Ø£Ùˆ ØªÙØ§Ø¹Ù„Ùƒ Ù…Ø¹
            Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† Ø¢Ø®Ø±ÙŠÙ†.
          </p>
        </div>

        {/* 20. Ø§Ù„Ø¥Ù†Ù‡Ø§Ø¡ */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">20. Ø§Ù„Ø¥Ù†Ù‡Ø§Ø¡</h2>
          <p>
            ØªØ­ØªÙØ¸ PTfinderNow Ø¨Ø§Ù„Ø­Ù‚ ÙÙŠ ØªØ¹Ù„ÙŠÙ‚ Ø£Ùˆ Ø¥Ù†Ù‡Ø§Ø¡ Ø§Ù„Ø­Ø³Ø§Ø¨Ø§Øª ÙÙŠ Ø£ÙŠ ÙˆÙ‚ØªØŒ Ù…Ø¹ Ø£Ùˆ
            Ø¨Ø¯ÙˆÙ† Ø¥Ø´Ø¹Ø§Ø± Ù…Ø³Ø¨Ù‚ØŒ Ù„Ø­Ù…Ø§ÙŠØ© Ø§Ù„Ù…Ù†ØµØ© Ø£Ùˆ Ø§Ù„Ù…Ø³ØªØ®Ø¯Ù…ÙŠÙ† Ø£Ùˆ Ø§Ù„Ù…ØµØ§Ù„Ø­ Ø§Ù„Ù‚Ø§Ù†ÙˆÙ†ÙŠØ©.
          </p>
        </div>

        {/* 21. Ø§Ù„Ù‚Ø§Ù†ÙˆÙ† Ø§Ù„Ù…Ø·Ø¨Ù‚ */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">21. Ø§Ù„Ù‚Ø§Ù†ÙˆÙ† Ø§Ù„Ù…Ø·Ø¨Ù‚</h2>
          <p>
            ØªØ®Ø¶Ø¹ Ù‡Ø°Ù‡ Ø§Ù„Ø´Ø±ÙˆØ· Ù„Ù‚ÙˆØ§Ù†ÙŠÙ† Ø¯ÙˆÙ„Ø© Ø§Ù„Ø¥Ù…Ø§Ø±Ø§Øª Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© Ø§Ù„Ù…ØªØ­Ø¯Ø©. ÙˆØ£ÙŠ Ù†Ø²Ø§Ø¹ ÙŠÙƒÙˆÙ†
            Ø®Ø§Ø¶Ø¹Ù‹Ø§ Ù„Ù„Ø§Ø®ØªØµØ§Øµ Ø§Ù„Ù‚Ø¶Ø§Ø¦ÙŠ Ø§Ù„Ø­ØµØ±ÙŠ Ù„Ù…Ø­Ø§ÙƒÙ… Ø¯Ø¨ÙŠØŒ Ø§Ù„Ø¥Ù…Ø§Ø±Ø§Øª Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© Ø§Ù„Ù…ØªØ­Ø¯Ø©.
          </p>
        </div>

        {/* 22. Ø§Ù„ØªØ¹Ø¯ÙŠÙ„Ø§Øª Ø¹Ù„Ù‰ Ø§Ù„Ø´Ø±ÙˆØ· */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">
            22. Ø§Ù„ØªØ¹Ø¯ÙŠÙ„Ø§Øª Ø¹Ù„Ù‰ Ø§Ù„Ø´Ø±ÙˆØ·
          </h2>
          <p>
            ÙŠØ¬ÙˆØ² Ù„Ù€ PTfinderNow ØªØ­Ø¯ÙŠØ« Ù‡Ø°Ù‡ Ø§Ù„Ø´Ø±ÙˆØ· ÙÙŠ Ø£ÙŠ ÙˆÙ‚Øª. ÙˆÙŠÙØ¹Ø¯ Ø§Ø³ØªÙ…Ø±Ø§Ø± Ø§Ø³ØªØ®Ø¯Ø§Ù…
            Ø§Ù„Ù…Ù†ØµØ© Ù…ÙˆØ§ÙÙ‚Ø© Ø¹Ù„Ù‰ Ø§Ù„Ø´Ø±ÙˆØ· Ø§Ù„Ù…ÙØ­Ø¯Ù‘Ø«Ø©.
          </p>
        </div>

        {/* 23. ØªÙˆØ§ØµÙ„ Ù…Ø¹Ù†Ø§ */}
        <div>
          <h2 className="text-2xl font-semibold mb-2">23. ØªÙˆØ§ØµÙ„ Ù…Ø¹Ù†Ø§</h2>
          <p>
            Ù„Ø£ÙŠ Ø§Ø³ØªÙØ³Ø§Ø±Ø§Øª Ø¨Ø®ØµÙˆØµ Ù‡Ø°Ù‡ Ø§Ù„Ø´Ø±ÙˆØ·ØŒ ÙŠØ±Ø¬Ù‰ Ø§Ù„ØªÙˆØ§ØµÙ„ Ø¹Ø¨Ø±{" "}
            <a
              href="mailto:info@ptfindernow.com"
              className="text-blue-500 hover:underline"
            >
              info@ptfindernow.com
            </a>
            .
          </p>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;

